export default "__VITE_ASSET__DMlk93cy__"